import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import UserDetails from '../UserDetails';
import { useAuth } from '../../../../context/useAuth';

const UserDetailsModal = ({ isOpen, onClose }) => {
  const { user } = useAuth();

  return (
    <Modal
      className="account_details_modal"
      width={520}
      open={isOpen}
      title="Detalji korisnika"
      onCancel={onClose}
      closable
      footer={null}
    >
      <UserDetails user={user} />
    </Modal>
  );
};

UserDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UserDetailsModal;
